// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../../engines/components/BaseComponent";
import O1HD from "../../../../../engines/gameEngine";
import utilsView from "../../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../../BundleResourceConfig";

const {ccclass, property} = cc._decorator;

/** 说话背景和文字位置差 */
const c_TalkSpaceY = 76;
const c_opacityTime = 0.25;
@ccclass
export default class SettleLawsuitSpecialPeopleNode extends BaseComponent {

	@property({ type: cc.Node, displayName:'' })
	nodeTalk: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelTalk: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	sprTalkBg: cc.Node = null;

    @property(cc.Label)
    labelName: cc.Label = null;

    @property(cc.Sprite)
    sprPeople: cc.Sprite = null;
    
    /** 最小高度 */
    private minTalkHeight = 0;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.minTalkHeight = this.sprTalkBg.height;
        this.nodeTalk.active = false;
        this.initUI();
    }

    initUI() {
        let id = this._carryData.id;
        let info = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.LEGAL_CASE_PEOPLE, id);
        if (!info) {
            console.error(`未找到头像数据`);
            return;
        }

        this.labelName.string = info.name;

        this.sprPeople.node.active = false;
        let meHead = "res/common/person/big/" + info.icon_max;
        getOneBundleByInstant(BUNDLE_SMALL_NAME.settleLawsuitBundle).load(meHead, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    this.sprPeople.node.active = true;
                    this.sprPeople.spriteFrame = imgs;
                }
            }
        );
    }

    onClick() {
        this._carryData.parent.closeAllPeopleTalk();
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.showTalk(this._carryData.strTalk);

        cc.Tween.stopAllByTarget(this.nodeTalk);
        this.nodeTalk.active = true;
        this.nodeTalk.opacity = 0;
        const time = c_opacityTime;
        cc.tween(this.nodeTalk)
        .to(time, {opacity: 255})
        .delay(2)
        .to(time, {opacity: 0})
        .call(()=> {
            this.nodeTalk.active = false;
        })
        .start();
    }

    showTalk(str: string) {
        this.labelTalk.string = str;

        utilsView.refreshLabelUI(this.labelTalk);
        let height = this.labelTalk.node.height;
        height = Math.max(height + c_TalkSpaceY, this.minTalkHeight);
        this.sprTalkBg.height = height;
    }

    hideTalk() {
        if (!this.nodeTalk.active) {
            return;
        }
        cc.Tween.stopAllByTarget(this.nodeTalk);
        this.nodeTalk.active = false;

        // cc.tween(this.nodeTalk)
        // .to(c_opacityTime, {opacity: 0})
        // .call(()=> {
        //     this.nodeTalk.active = false;
        // })
        // .start();
    }

    // update (dt) {}
}
